
webshop.ProductList = class {
   /* Options:
     - items: Items
     - settings: Webshop Settings
     - products_section: Products Wrapper
     - preference: If preference is not list view, render but hide
   */
   constructor(options) {
      Object.assign(this, options);

      if (this.preference !== "List View") {
         this.products_section.addClass("hidden");
      }

      // تعديل هنا: إذا لم يكن appendMode، أفرغ المنطقة
      if (!this.appendMode) {
         this.products_section.empty();
      }
      this.make();
   }

   make() {
      let me = this;
      let html = `<br><br>`;

      this.items.forEach((item) => {
         let title = item.web_item_name || item.item_name || item.item_code || "";
         title = title.length > 200 ? title.substr(0, 200) + "..." : title;

         html += `<div class='row list-row'>`;
         html += me.get_image_html(item, title, me.settings);
         html += me.get_row_body_html(item, title, me.settings);
         html += `</div>`;
      });

      let $product_wrapper = this.products_section;
      $product_wrapper.append(html);
   }

   get_image_html(item, title, settings) {
      let image = item.website_image;
      let wishlist_enabled = !item.has_variants && settings.enable_wishlist;
      let image_html = ``;

      if (image) {
         image_html += `
        <div class="col-6 border text-center rounded list-image">
          <a class="product-link product-list-link" href="/${item.route || "#"}">
            <img itemprop="image" class="website-image" alt="${title}"
              src="${image}">
          </a>
          ${wishlist_enabled ? this.get_wishlist_icon(item) : ""}
        </div>
      `;
      } else {
         image_html += `
        <div class="col-6 border text-center rounded list-image">
          <a class="product-link product-list-link" href="/${item.route || "#"}"
            style="text-decoration: none">
            <div class="card-img-top no-image-list">
              ${frappe.get_abbr(title)}
            </div>
          </a>
          ${wishlist_enabled ? this.get_wishlist_icon(item) : ""}
        </div>
      `;
      }

      return image_html;
   }

   get_row_body_html(item, title, settings) {
      let body_html = `<div class='col-6 text-left'>`;
      body_html += this.get_title_html(item, title, settings);
      body_html += this.get_item_details(item, settings);
      body_html += `</div>`;
      return body_html;
   }

   get_title_html(item, title, settings) {
      let title_html = `<div class="custom-style-title-item" >`;
      title_html += `
      <div class="custom-style-title-item-s1" style="margin-right: -15px;">
        <a class="" href="/${item.route || "#"}"
          style="color: var(--gray-800); font-weight: 500;">
          ${title}
        </a>
      </div>
    `;

      if (settings.enabled) {
         title_html += `<div class="cart-action-container custom-style-title-item-s2 ${item.in_cart ? "d-flex" : ""
            }">`;
         // زر إضافة للسلة
         title_html += this.get_primary_button(item, settings);

         // أيقونة مشاركة واتساب
         const productUrl = `${window.location.origin}/${item.route || "#"}`;
         title_html += `
        <a href="https://wa.me/?text=${encodeURIComponent(productUrl)}" target="_blank" title="${__("Share on WhatsApp")}" style="margin-left:8px; color:#25D366; font-size:18px;">
          <i class="fab fa-whatsapp"></i>
        </a>
      `;

         // أيقونة نسخ الرابط
         title_html += `
        <a href="#" onclick="navigator.clipboard.writeText('${productUrl}'); return false;" title="${__("Copy product link")}" style="margin-left:8px; color:#555; font-size:18px;">
          <i class="fa fa-link"></i>
        </a>
      `;

         title_html += `</div>`;
      }
      title_html += `</div>`;

      return title_html;
   }

   get_item_details(item, settings) {
      let details = `
      <p class="product-code">
         <div>
         ${__(item.item_group)}
         </div>
      <div>
        ${__(item.item_code)}
      </div> 
      </p>
         <div class="bmn-style-list">
         <div class="brand-style">
          ${__("Brand")} : ${__(item.brand)}
         </div>
         <div class="brand-model-style">
          ${__("Model Name")} :  ${__(item.brand_model)}
         </div>
         <div class="brand-model-style">
          ${__("Supplier")} :  ${__(item.supplier_name)}
         </div>
         </div>
      <div class="mt-2" style="color: var(--gray-600) !important; font-size: 13px;">
        ${__(item.short_description) || ""}
      </div>
      <div class="product-price" itemprop="offers" itemscope itemtype="https://schema.org/AggregateOffer">
        ${item.formatted_price || ""}
    `;

      if (item.formatted_mrp) {
         details += `
        <small class="striked-price">
          <s>${item.formatted_mrp ? item.formatted_mrp.replace(/ +/g, "") : ""}</s>
        </small>
        <small class="ml-1 product-info-green">
          ${item.discount} ${__("OFF")}
        </small>
      `;
      }

      details += this.get_stock_availability(item, settings);
      details += `</div>`;

      return details;
   }

   get_stock_availability(item, settings) {
      if (settings.show_stock_availability && !item.has_variants) {
         if (item.on_backorder) {
            return `
          <br>
          <span class="out-of-stock mt-2" style="color: var(--primary-color)">
            ${__("Available on backorder")}
          </span>
        `;
         } else if (!item.in_stock) {
            return `
          <br>
          <span class="out-of-stock mt-2 d-none">${__("Out of stock")}</span>
        `;
         } else if (item.is_stock) {
            return `
          <br>
          <span class="in-stock in-green has-stock mt-2"
            style="font-size: 14px;">${__("In stock")}</span>
        `;
         }
      }
      return ``;
   }

   get_wishlist_icon(item) {
      let icon_class = item.wished ? "wished" : "not-wished";

      return `
      <div class="like-action-list ${item.wished ? "like-action-wished" : ""}"
        data-item-code="${item.item_code}">
        <svg class="icon sm">
          <use class="${icon_class} wish-icon" href="#icon-heart"></use>
        </svg>
      </div>
    `;
   }
   // ${ settings.enable_checkout ? __("Add to Cart") :  __("Add to Quote") }
   get_primary_button(item, settings) {
      if (item.has_variants) {
         return `
        <a href="/${item.route || "#"}">
          <div class="btn btn-sm btn-explore-variants btn mb-0 mt-0">
            ${__("Explore")}
          </div>
        </a>
      `;
      } else if (
         settings.enabled &&
         (settings.allow_items_not_in_stock || item.in_stock)
      ) {
         return `
        <div id="${item.name}" class="btn
          btn-sm btn-primary btn-add-to-cart-list custom-btn-add-to-cart-list mb-0
          ${item.in_cart ? "hidden" : ""}"
          data-item-code="${item.item_code}"
          style="margin-top: 0px !important; max-height: 30px; 
            padding: 0.25rem 1rem;">
          <span">
            <svg class="icon icon-md">
              <use href="#icon-assets"></use>
            </svg>
          </span>
          
        </div>

        <div class="cart-indicator list-indicator ${item.in_cart ? "" : "hidden"}">
          1
        </div>

        <a href="/cart">
          <div id="${item.name}" class="btn
            btn-sm btn-primary btn-add-to-cart-list custom-btn-add-to-cart-list
            ml-4 go-to-cart mb-0 mt-0
            ${item.in_cart ? "" : "hidden"}"
            data-item-code="${item.item_code}"
            style="padding: 0.25rem 1rem; min-width: 135px;">
            ${settings.enable_checkout
               ? `<svg class="icon icon-md"><use href="#icon-right"></use></svg>`
               : `<svg class="icon icon-md"><use href="#icon-right"></use></svg>`
            }
          </div>
        </a>
      `;
      } else {
         return ``;
      }
   }
};
